<div class="row justify-content-center p-0 m-0" *ngIf="authDescription">
  <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 p-0 pt-5 m-0">
    <div class="alert alert-warning">
      {{authDescription}}
    </div>
  </div>
</div>
<div class="row justify-content-center pt-4 m-0">
  <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 p-0 m-0">
    <quick-preview-panel
      [heading]="'Login'"
      [color]="'primary'"
    >
      <form [formGroup]="loginForm" class="p-4">
        <div>
          <mat-form-field class="d-block">
            <mat-label>Username</mat-label>
            <input type="text" matInput class="d-block"
                   formControlName="username">
            <mat-error>
              Required field
            </mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="d-block">
            <mat-label>Password</mat-label>
            <input type="password" matInput class="d-block" autocomplete="on"
                   formControlName="password">
            <mat-error>
              Required field
            </mat-error>
          </mat-form-field>
        </div>
      </form>
      <actions-container [ngClass]="'pb-4'">
        <div class="d-inline m-0 mt-0 p-0 pt-0">
          <div id="g_id_onload"
               data-client_id="218236813951-1454tc93jpkvo8c8iho8luuiqbgl44sg.apps.googleusercontent.com"
               data-context="signin"
               data-ux_mode="redirect"
               data-login_uri="http://localhost:8001/oauth2/google/sign-in"
               data-auto_select="true"
               data-itp_support="true">
          </div>
          <div class="g_id_signin" [attr.data-state]="stateId"
               data-type="standard"
               data-shape="rectangular"
               data-theme="outline"
               data-text="signin_with"
               data-size="large"
               data-logo_alignment="left">
          </div>
        </div>
        <div class="pe-4">
          <button [disabled]="!loginForm.valid" mat-raised-button color="primary" (click)="submit()">Login</button>
        </div>
      </actions-container>
    </quick-preview-panel>
    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
    <div class="my-4">
      <auth-user-account-info></auth-user-account-info>
    </div>
    <div class="my-4" *ngIf="error">
      <error-panel [error]="error"></error-panel>
    </div>
  </div>
</div>
